export const PROMO_SCREENSHOTS = {
  chat: 'https://sadaycaresolution.blob.core.windows.net/media/images/promo/promo-chat.png',
  map: 'https://sadaycaresolution.blob.core.windows.net/media/images/promo/promo-map.png',
  trend: 'https://sadaycaresolution.blob.core.windows.net/media/images/promo/promo-trend.png',
};

/**
 * The portrait chat capture is shown in a landscape browser frame.
 * Pan between its question suggestions and composer without zooming.
 */
export const PROMO_CHAT_HERO_MOTION = {
  durationS: 12,
  bottomOffsetPercent: -65,
};
